// Parsea YYYY-MM-DD como fecha LOCAL (new Date('2026-04-01') se corre un dia en Argentina).
function parseFechaLocal(value: string | Date): Date {
  if (value instanceof Date) return value;
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  return new Date(value);
}

export function formatDate(value: string | Date | null | undefined): string {
  if (!value) return '-';
  const d = parseFechaLocal(value);
  return isNaN(d.getTime()) ? '-' : new Intl.DateTimeFormat('es-AR').format(d);
}

export function formatDateTime(value: string | Date | null | undefined): string {
  if (!value) return '-';
  const d = typeof value === 'string' ? new Date(value) : value;
  return isNaN(d.getTime()) ? '-' : new Intl.DateTimeFormat('es-AR', { dateStyle: 'short', timeStyle: 'short' }).format(d);
}

export function formatCurrency(value: number | null | undefined): string {
  if (value == null || isNaN(Number(value))) return '-';
  return new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS', minimumFractionDigits: 2 }).format(Number(value));
}

const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

/** '2026-04' -> 'Abril 2026' */
export function formatPeriodo(periodo: string): string {
  const m = /^(\d{4})-(\d{2})$/.exec(periodo);
  if (!m) return periodo;
  const mes = MESES[Number(m[2]) - 1];
  return mes ? `${mes.charAt(0).toUpperCase()}${mes.slice(1)} ${m[1]}` : periodo;
}

export function formatBytes(n: number | null | undefined): string {
  if (!n) return '';
  return n < 1024 * 1024 ? `${Math.max(1, Math.round(n / 1024))} KB` : `${(n / 1024 / 1024).toFixed(1)} MB`;
}
